import { render, staticRenderFns } from "./auto-copilot.vue?vue&type=template&id=d5daa182&scoped=true"
import script from "./auto-copilot.vue?vue&type=script&lang=js"
export * from "./auto-copilot.vue?vue&type=script&lang=js"
import style0 from "./auto-copilot.vue?vue&type=style&index=0&id=d5daa182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5daa182",
  null
  
)

export default component.exports